import React from "react"
import Link from './link'
import Image from "./image";
import BirthdayHomePlaceholder from '../images/birthday-home-placeholder.png'
import { getGG } from '../state/store'
import { ga4 } from '../handlers/google-analytic'

class BirthdayHome extends React.Component {
  setGaBirthday = () => {
    const { birthdayTitle, birthdayNewsCode } = this.props
    const { user } = getGG().store.getState()
    ga4.gtag('event', 'birthday_home', {
      privilege_name: birthdayTitle,
      category: 'birthday_home',
      trigger: `birthdayHomeButtonId-${birthdayNewsCode}`,
      profile_id: user.profileId,
    })
  }
  render() {
    const { birthdayImage } = this.props
    return (
      <div className={`birthday-home`}>
        <Link to={`/birthday-privileges`} onClick={this.setGaBirthday}>
          <Image
            src={birthdayImage}
            placeholder={BirthdayHomePlaceholder}
          />
        </Link>
      </div>
    )
  }
}

export default BirthdayHome
